import { render, staticRenderFns } from "./Opinions.vue?vue&type=template&id=5b068b03&"
import script from "./Opinions.vue?vue&type=script&lang=js&"
export * from "./Opinions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports